import * as THREE from '@phdsoft/three';
import { Injectable } from '@angular/core';
import { Graphics } from './graphics';
import { Asset } from 'src/app/platform/busines-data/Framework/Asset';
import { PointsRender } from '../utmPoints/graphics-render-pointShape';
import { DecalSelectionService } from '../selection/decalSelection';

@Injectable({ providedIn: 'root' })
export class GraphicsRenderCriticalArea {

  constructor(
    private graphics: Graphics,
    private decalSelection: DecalSelectionService,
    private pointsRender: PointsRender
    ) { }

  private _mousePosition: THREE.Vector3;

  private get mousePosition(): THREE.Vector3 {
    return this._mousePosition
  }

  private setMousePosition(event: any){
    this._mousePosition = new THREE.Vector3((((event.clientX ? event.clientX : event.center.x) - this.graphics.offsetX) / window.innerWidth) * 2 - 1,
    -(((event.clientY ? event.clientY : event.center.y) - this.graphics.offsetY) / window.innerHeight) * 2 + 1, 0.5);
  }

  private initSelectionDecal(asset: Asset) {
    this.decalSelection.setAsset(asset);
    this.decalSelection.setCamera(this.graphics.camera);
  }

  public createBoxOnPosition(event, asset?: Asset, currentSectionId?: string) {
    this.initSelectionDecal(asset);
    event = event.changedTouches ? event.changedTouches[0] : event;
    this.setMousePosition(event);

    const pointData = this.getPointOverMouse("", asset, currentSectionId);
    const box = this.pointsRender.returnBox(pointData.point);

    return box;
  }

  public createPointOnPosition(event, asset?: Asset, currentSectionId?: string) {
    this.initSelectionDecal(asset);
    event = event.changedTouches ? event.changedTouches[0] : event;
    this.setMousePosition(event);

    const pointData = this.getPointOverMouse("", asset, currentSectionId);
    const sphere = this.pointsRender.returnSpherePoint(pointData.point);

    return sphere;
  }

  private getPointOverMouse(type: string, asset?: Asset, currentSectionId?: string) {
    this.decalSelection.setAsset(asset);
    this.decalSelection.setCamera(this.graphics.camera);
    const _intersection = this.decalSelection.elementsUnderMouse(this.mousePosition, type, currentSectionId);
    if (_intersection.intersected != null) {
        return {
            target: _intersection.intersection.object, point: _intersection.intersection.point,
            normal: _intersection.intersection.normal, property: _intersection.intersection.property
        };
    }
    return null;
  }
}
